var _rect, _rect2, _rect3, _rect4, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 51,
    viewBox: "0 0 138 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0625305,
    width: 137.004,
    height: 50.7539,
    rx: 13.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 47.6826,
    y: 10.5689,
    width: 76.737,
    height: 5.32045,
    rx: 2.66022,
    fill: "#323F4B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 47.6826,
    y: 20.2671,
    width: 56.5163,
    height: 5.32045,
    rx: 2.66022,
    fill: "#323F4B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 47.6826,
    y: 34.8144,
    width: 21.9444,
    height: 5.32045,
    rx: 2.66022,
    fill: "#7B8794"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5775 31.3568C31.4562 31.3568 37.0324 25.7987 37.0324 18.9424C37.0324 12.0861 31.4562 6.528 24.5775 6.528C17.6988 6.528 12.1226 12.0861 12.1226 18.9424C12.1226 25.7987 17.6988 31.3568 24.5775 31.3568Z",
    fill: "#E4E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5803 23.5488C22.8174 23.7858 23.1271 23.904 23.4374 23.904C23.7478 23.904 24.0575 23.7858 24.2945 23.5488L30.3561 17.4873C30.8295 17.0139 30.8295 16.2465 30.3561 15.7731C29.8827 15.2997 29.1153 15.2997 28.6419 15.7731L23.4374 20.9769L20.6576 18.1977C20.1842 17.7243 19.4168 17.7243 18.9434 18.1977C18.47 18.6711 18.47 19.4385 18.9434 19.9119L22.5803 23.5488Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyList);
export default __webpack_public_path__ + "static/media/emptyList.afcb0aac68856c583f254f30a706596b.svg";
export { ForwardRef as ReactComponent };